module.exports = __webpack_public_path__ + "img/me.60de95bd.jpg";